/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {
    Col,
    Row
} from "react-bootstrap";
import React from "react";
import {config} from "../../../Config";

export const ActivityFeedErrorItem = (props) => {
    
    const {error} = props;
    
    if(config.getEnvironment() === 'prod') {
        return null;
    }
    
    return <Row className="sb-activity-feed-group-item">
        <Col xs={8} className="sb-activity-feed-group-item-summary">
            <h4 className="sb-activity-feed-group-item-summary-title">
                {error?.message ?? "Unexpected Error"}
            </h4>
            <pre>
                {error?.stack ? error.stack : "No stack trace available."}
            </pre>
        </Col>
    </Row>
}
